import {
  CreateRecommendedFilterRequestDto,
  DiseaseGroupResponseDto,
  TherapistSearchRequestDtoOrderEnum,
  TherapistSearchRequestDtoOrderTermsEnum,
  TherapistSearchResponseDto,
  TherapyMethodResponseDto,
} from '@app/api';

import { COLORS, TYPOGRAPHY } from '@app/constants';
import { useClientSize, useToggle } from '@app/hooks/';
import { useHasMounted } from '@app/hooks/useHasMounted';
import { useOnClickOutside } from '@app/hooks/useOnClickOutside';
import { actions, selectors } from '@app/store';
import { BreakpointsEnum, IFilter, TabData, TherapistData } from '@app/types';
import Button from '@app/ui/components/Button';
import Modal from '@app/ui/components/Modal';
import SearchInput from '@app/ui/components/SearchInput';
import { Arrow, Setting, SortDescending } from '@app/ui/iconComponents';
import React, { useCallback, FC, useRef, useState, useEffect, Dispatch, SetStateAction } from 'react'; //, useMemo
import { FieldValues } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { SearchNothingFoundState, Sorting } from './components';
import { ImperativeHandleProps } from './components/List';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { useRouter } from 'next/router';
import { isInterviewDone } from '@app/helpers/isInterviewDone';
import TypedLink from '@app/components/TypedLink';
import { useGetDiseasesGroupsQuery } from '@app/store/api/common';
import { getInterviewFromStorage } from '@app/services/storageService';
import { isEmptyObject } from '@app/utils/isEmptyObject';
import { useFilterBannerManager } from '../lib/useFilterBannerManager';
import SignUpModal from '@app/components/SignUpModal';

import {
  convertAppliedFiltersToQueryParams,
  formatQueryParamsToFilter,
  mergeInitialFiltersAndFieldValues,
} from '../utils';

import Pagination from '@app/ui/components/Pagination';
import {
  MAX_THERAPISTS_IN_LIST,
  iGetWithFiltersResponse,
} from '@app/backend/therapists/getTherapistsWithFilter';
import { iLoadTherapistParamsFromPage } from '@app/hoc/withFilterLogic';
import getViewedRowsFromPageStats from '@app/utils/getViewedRowsFromPageAndTotal';
import Tabs from '@app/ui/components/Tabs';
import Sidebar from '../Sidebar';
import InformationBlock from '@/landing/components/InformationBlock';
import SpecialistCardNew from '@/app/ui/components/SpecialistCard/SpecialistCardNew';
import { useSignupClickHandler } from '@/app/hooks/useSignUpHandler';
import EnrollModal from '@/app/components/EnrollModal';
import HelpChooseChildPsy2 from '@/app/ui/components/HelpChooseChildPsy2';
import { sendMetrik } from '@/app/utils/sendMetrik';
import FlatBtn from '@/app/ui/components/FlatBtn';

interface Props {
  className?: string;
  defaultTab: string | null;

  pageTitle?: string;
  initialTotalPage?: number;
  initialTotal: number;
  initialCount: number;
  initialFilters?: IFilter[];

  page: number;
  setPage: (p: number) => void;
  currentUrl: string;
  therapists: Array<TherapistSearchResponseDto>;
  setTherapists: (array: Array<TherapistSearchResponseDto>) => void;
  loadTherapists: (
    p: iLoadTherapistParamsFromPage,
  ) => Promise<iGetWithFiltersResponse>;

  applyAndSaveAllSelectedFilters: (p?: number | undefined, childAgeValue?: number | undefined, therapistAgeValue?: string | undefined) => void;

  crutchDiseasesGroups?: any;
  crutchTherapyMethods?: any;
  crutchFilters?: any;

  dummy?: any;
  setDummy?: any;

  childTherapists?: boolean;
  isSupervisorTherapist?: boolean;
  childAge?: number;
  setChildAge?: Dispatch<SetStateAction<number>>;
  therapistAge?: string | undefined;
  setTherapistAge?: Dispatch<SetStateAction<string | undefined>>;

  openModalForm?: () => void;

  showBookSessionButtons?: boolean,
}

export enum AllTherapistsTab {
  all = 'all',
  recommended = 'recommended',
}

export enum TypeCard {
  original = 'original',
  small = 'small',
}

const tabsData: TabData[] = [
  {
    text: 'Все',
    value: AllTherapistsTab.all,
  },
  {
    text: 'Рекомендованные',
    value: AllTherapistsTab.recommended,
  },
];

const AllTherapists: FC<Props> = (props) => {
  const {
    className,
    defaultTab,

    pageTitle,
    initialTotal,
    initialTotalPage,
    initialCount,
    initialFilters,

    page,
    setPage,
    currentUrl,
    therapists,
    loadTherapists,

    applyAndSaveAllSelectedFilters,

    crutchDiseasesGroups,
    crutchTherapyMethods,
    crutchFilters,

    dummy,
    setDummy,

    childTherapists,
    isSupervisorTherapist,
    childAge,
    setChildAge,
    therapistAge,
    setTherapistAge,

    openModalForm,
    showBookSessionButtons,
  } = props;

  const dispatch = useAppDispatch();

  const queryFilters = useAppSelector(
    selectors.allTherapistsFilters.selectQueryFilters,
  );

  const selectedFiltersValues = useAppSelector(
    selectors.allTherapistsFilters.selectSelectedFiltersValues,
  );

  const selectedFiltersDiseases = useAppSelector(
    selectors.allTherapistsFilters.selectSelectedFiltersDiseases,
  );

  const hasMounted = useHasMounted();
  const router = useRouter();
  const { query } = router;
  const userRole = useAppSelector(selectors.auth.selectRole);
  const isAuth = !!useAppSelector(selectors.auth.selectToken);
  const metadata = useAppSelector(selectors.auth.selectMetadata);
  const listRef = useRef<ImperativeHandleProps>(null);
  const searchValue = useAppSelector(
    selectors.allTherapistsFilters.selectSearchValue,
  );
  const [typeCard, setTypeCard] = useState<TypeCard>(TypeCard.small);

  const [total, setTotal] = useState<number>(initialTotal);
  const [count, setCount] = useState<number>(initialCount);
  // SSR доработки конец

  const sortParams = useAppSelector(
    selectors.allTherapistsFilters.selectSortParams,
  );

  const interview =
    hasMounted && getInterviewFromStorage()
      ? getInterviewFromStorage()
      : ({} as CreateRecommendedFilterRequestDto);

  const hasInterviewDoneLocalStorage = !isEmptyObject(interview);

  const [allTherapistsQueryParams, setAllTherapistsQueryParams] = useState<
    Record<string, any> | undefined
  >(undefined);

  const resetList = useCallback(() => {
    if (!listRef.current) return;

    listRef?.current?.reset();
    setPage(1);
    // TODO dispatch page
  }, []);

  const activeTab = useAppSelector(
    selectors.allTherapistsFilters.selectActiveTab,
  );

  const handleToggleTab = (tab: AllTherapistsTab) => {
    // setActiveTab(tab);

    if (tab === AllTherapistsTab.all) {
      const urlWithoutFilters = '/all-therapists/';
      const currentDomain = window.location.origin;
      const urlWithParams = `${currentDomain}${urlWithoutFilters}`;
      window.location.href = urlWithParams;
    }

    dispatch(actions.allTherapistsFilters.setActiveTab({ tabPayload: tab }));
  };

  // useEffect(() => { //remove

  //   if ( !activeTab ) return
  //   applyAndSaveAllSelectedFilters()

  // }, [ activeTab ])

  const fetchQueryFilterParams = (
    filters: IFilter[],
    diseasesGroups: DiseaseGroupResponseDto[],
    therapyMethods: TherapyMethodResponseDto[],
  ) => {
    if (pageTitle) {
      return;
    }

    const { diseases, religions } = formatQueryParamsToFilter({
      // query: { diseases: [ therapists.diseaseId ] },
      query: { diseases: [] }, //TODO urls
      filters,
      diseasesGroups,
    });

    // console.log(`diseases ${ typeof diseases }`, diseases );

    const selectedFilters = mergeInitialFiltersAndFieldValues({
      filters,
      data: {
        diseases,
        religions,
      },
    });

    const queryFilters = convertAppliedFiltersToQueryParams({
      page,
      selectedFiltersValues,
      selectedFiltersDiseases,
    });

    dispatch(
      actions.allTherapistsFilters.setSelectedFilters({ selectedFilters }),
    );
    dispatch(actions.allTherapistsFilters.setQueryFilters({ queryFilters }));

    setTimeout(() => {
      setDummy(Math.random() * 1000);
    }, 1500);
  };

  const [isFirstlyFilterSetted, setIsFirstlyFilterSetted] = useState(false);

  useEffect(() => {
    if (isFirstlyFilterSetted || !setDummy) {
      return;
    }

    if (!crutchFilters) {
      setTimeout(() => {
        setDummy(99999);
      }, 1500);
      return;
    }

    if (dummy !== 99999) {
      return;
    }

    fetchQueryFilterParams(
      crutchFilters,
      crutchDiseasesGroups,
      crutchTherapyMethods,
    );
    setIsFirstlyFilterSetted(true);
  }, [crutchFilters?.length, dummy]);

  const { data: diseasesGroups } = useGetDiseasesGroupsQuery({ isChild: false });

  const { CurrentBanner, sleepProblemsId } = useFilterBannerManager({
    diseasesGroups,
    query: allTherapistsQueryParams,
  });

  useEffect(() => {
    resetList();
  }, [queryFilters, sortParams, activeTab]);

  useEffect(() => {
    count === 0 && total !== 0 && page > 1 && handleSetPage(1);
  }, [count, total, page]);

  const {
    state: isFiltersOpen,
    toggle: toggleFiltersOpen,
    open: openFilters,
    close: closeFilters,
  } = useToggle();

  const {
    state: isSortingOpen,
    toggle: toggleSortingOpen,
    close: closeSorting,
  } = useToggle();

  const sortingRef = useRef(null);

  const handleSearch = useCallback((value?: string) => {
    dispatch(actions.allTherapistsFilters.setSearchValue(value || ''));
  }, []);

  const { getIsBreakpoint } = useClientSize();
  const isMobile = getIsBreakpoint('sm');

  useOnClickOutside(sortingRef, () => !isMobile && closeSorting());

  const handleSorting = ({ sort }: FieldValues) => {
    if (sort) {
      const separateSorting = sort.split('_');

      const params = {
        order: separateSorting[0] as TherapistSearchRequestDtoOrderEnum,
        orderTerms:
          separateSorting[1] as TherapistSearchRequestDtoOrderTermsEnum,
      };

      dispatch(
        actions.allTherapistsFilters.setSortingParams({
          sortingPayload: params,
        }),
      );

      // toggleSortingOpen();
    }
  };

  // const handleReachEnd = () => { // old infinity scroll
  //   setPage(page + 1);
  // };

  const isFiltersMobileModalOpen = isMobile && isFiltersOpen;

  const isSortingDesktopOpen = !isMobile && isSortingOpen;
  const isSortingMobileOpen = isMobile && isSortingOpen;

  const shouldShowTherapistsTotal = true;

  // useMemo(() => {

  //   const shouldShowTherapistsTotal = useMemo(() => {

  //   return (

  //     Object.values(queryFilters ?? {}).some((item) => {

  //       if (Array.isArray(item)) {
  //         return item.length !== 0;
  //       }

  //       return item !== undefined;

  //     }) || !!searchValue

  //   );

  // }, [queryFilters, searchValue]);

  const hasTabs =
    hasMounted &&
    (isInterviewDone({ userRole, metadata }) || hasInterviewDoneLocalStorage);

  const isAuthModalOpen = useAppSelector(selectors.auth.selectAuthModalState);

  const onCloseSignUpModal = () => {
    dispatch(
      actions.auth.setSignUpContext({
        mode: 'normal',
      }),
    );

    dispatch(actions.auth.setAuthModalState(false));
  };

  const isRow = !isMobile && typeCard === TypeCard.original;
  const isSmall = !isMobile && typeCard === TypeCard.small;

  function handleSetPage(p: number) {
    query.page = p.toString(); // Обновляем значение параметра 'page'

    const queryParams: Record<string, string> = {};

    Object.keys(router.query).forEach((key) => {
      const value = router.query[key];

      if (Array.isArray(value)) {
        queryParams[key] = value[0];
      } else {
        queryParams[key] = value?.toString() || '';
      }
    });

    const childOld = Number(router.query.childOld) || undefined;
    const therapistOld = router.query.therapistOld?.toString() || undefined;

    childOld && (queryParams.childOld = childOld.toString());
    therapistOld && (queryParams.therapistOld = therapistOld);

    queryParams.page = p.toString();

    const queryStr = new URLSearchParams(queryParams).toString();
    const currentPath = router.asPath.split('?')[0];

    let updSelectedFiltersValues = { ...selectedFiltersValues };

    updSelectedFiltersValues = {
      ...updSelectedFiltersValues,
      page: p,
      therapistOld: therapistOld,
      childOld: childOld,
    };

    dispatch(
      actions.allTherapistsFilters.setSelectedFiltersValues({
        selectedFiltersValues: updSelectedFiltersValues,
      }),
    );

    setPage(p);
    applyAndSaveAllSelectedFilters(p, childOld, therapistOld);
    router.push(`${currentPath}?${queryStr}`);
  }

  const {

    handleClickSignupButton,
    isEnrollModalOpen,
    toggleEnrollModalOpen,

  } = useSignupClickHandler();

  const [enrollTherapist, setEnrollTherapist] = useState<TherapistData | null>(null);
  const [enrollTherapistId, setEnrollTherapistId] = useState<string>();

  const gotoPaymentSession = (availabilityId: string) => {
    const paySessionUrl = `/session-payment?availabilityId=${availabilityId}`;

    if (!isAuth) {
      localStorage.setItem('paySessionUrlRedirect', paySessionUrl);
    }

    toggleEnrollModalOpen();
    router.push(paySessionUrl);
  };

  useEffect(() => {
    const paySessionUrlRedirect = localStorage.getItem('paySessionUrlRedirect');

    if (paySessionUrlRedirect) {
      localStorage.removeItem('paySessionUrlRedirect');
      router.push(paySessionUrlRedirect)
    }

  }, []);

  const handleSelectTherapist = () => {
    sendMetrik('reachGoal', 'child_select_specialist');

    if (childTherapists) {
      openModalForm && openModalForm();
    }
  }

  return (
    <Root className={className}>

      {isMobile && !childTherapists && (
        <LinkButtonWrap>
          <TypedLink to="/client/interview">
            <LinkButton>
              <span>Подобрать специалиста</span>
            </LinkButton>
          </TypedLink>
        </LinkButtonWrap>
      )}

      {isMobile && childTherapists && (
        <LinkButtonWrap>
          <LinkButton onClick={handleSelectTherapist}>
            <span>Подобрать специалиста</span>
          </LinkButton>
        </LinkButtonWrap>
      )}

      {CurrentBanner && <CurrentBanner margin />}

      {page > 1 && (
        <StyledFlatBtn
          onClick={() => handleSetPage(page - 1)}
          icon={<Arrow width={16} height={16} color="currentColor" />}
        >
          Назад
        </StyledFlatBtn>
      )}

      {pageTitle && (
        <>
          <Title>{pageTitle}</Title>
        </>
      )}

      <Heading>
        <>
          Специалисты
          {isMobile && <br />}
          {shouldShowTherapistsTotal && (
            <>
              <>{' '}</>
              <span>
                {getViewedRowsFromPageStats({
                  page,
                  total,
                  limit: MAX_THERAPISTS_IN_LIST,
                }) > 0 && (
                    <>
                      {getViewedRowsFromPageStats({
                        page,
                        total,
                        limit: MAX_THERAPISTS_IN_LIST,
                      })}
                      {' из '}
                    </>
                  )}
                {total || 0}
              </span>
            </>
          )}
        </>
      </Heading>

      {hasTabs && (
        <StyledTabs
          data={tabsData}
          onToggle={handleToggleTab}
          activeValue={
            query.tab && !Array.isArray(query.tab)
              ? query.tab
              : AllTherapistsTab.all
          }
        />
      )}

      <StyledInputWrapper>

        <StyledSearchInput
          onSearch={() => {
            applyAndSaveAllSelectedFilters();
          }}
          onReset={() => {
            handleSearch('');
          }}
          isAllowEmptySearch={true}
          onChange={handleSearch}
          initValue={
            query.search && !Array.isArray(query.search) ? query.search : ''
          }
        />

        <Controls>
          <SortingWrap>
            <StyledButtonFilters
              styleType="tertiary"
              icon={<Setting width={20} height={20} />}
              onClick={toggleFiltersOpen}
              className="second-step"
            >
              Фильтры
            </StyledButtonFilters>

            <div ref={sortingRef}>
              <SortButton
                styleType="tertiary"
                icon={<SortDescending width={20} height={20} />}
                onClick={toggleSortingOpen}
                $hasSorting={false}
              >
                {'Сортировать'}
              </SortButton>

              {isSortingDesktopOpen && (
                <Sorting
                  onSorting={handleSorting}
                  applyAndSaveAllSelectedFilters={applyAndSaveAllSelectedFilters}
                  defaultValues={
                    sortParams.order && sortParams.orderTerms
                      ? {
                        sort: `${sortParams.order}_${sortParams.orderTerms}`,
                      }
                      : undefined
                  }
                />
              )}
            </div>

            <StyledModal
              isOpen={isSortingMobileOpen}
              onClose={toggleSortingOpen}
              heading="Сортировать"
            >
              <Sorting
                onSorting={handleSorting}
                applyAndSaveAllSelectedFilters={applyAndSaveAllSelectedFilters}
                defaultValues={
                  sortParams.order && sortParams.orderTerms
                    ? {
                      sort: `${sortParams.order}_${sortParams.orderTerms}`,
                    }
                    : undefined
                }
              />
            </StyledModal>

            <StyledModal
              isOpen={isFiltersMobileModalOpen}
              onClose={toggleFiltersOpen}
              withoutHeader
            >
              <Sidebar
                initialFilters={initialFilters}
                applyAndSaveAllSelectedFilters={(p?: number, childOld?: number | undefined, therapistOld?: string | undefined) => {
                  applyAndSaveAllSelectedFilters(p, childAge, therapistAge);
                  toggleFiltersOpen();
                }}
                childTherapists={childTherapists}
                isSupervisorTherapist={isSupervisorTherapist}
                childAge={childAge}
                setChildAge={setChildAge}
                therapistAge={therapistAge}
                setTherapistAge={setTherapistAge}
              />
            </StyledModal>
          </SortingWrap>

          <ButtonsWrap>
            {/* <StyledIconBtn onClick={() => setTypeCard(TypeCard.original)}>
              <Menu
                width={16}
                height={16}
                color={
                  typeCard === TypeCard.original
                    ? COLORS.grayscale600
                    : COLORS.grayscale300
                }
              />
            </StyledIconBtn> */}

            {/* <StyledIconBtn onClick={() => setTypeCard(TypeCard.small)}>
              <Category
                width={16}
                height={16}
                color={
                  typeCard === TypeCard.small
                    ? COLORS.grayscale600
                    : COLORS.grayscale300
                }
              />
            </StyledIconBtn> */}
          </ButtonsWrap>
        </Controls>

      </StyledInputWrapper>

      {!(therapists?.length > 0) ? <SearchNothingFoundState /> : (

        <TherapistsList $isRow={isRow}>

          {therapists.map((item: TherapistSearchResponseDto) => (

            <SpecialistCardNew

              key={item.id}
              data={item}
              child={childTherapists}
              showBookSessionButton={showBookSessionButtons}

              handleClickSignupButton={(therapist: TherapistData) => {

                setEnrollTherapistId(therapist.id);
                setEnrollTherapist(therapist);
                toggleEnrollModalOpen();
              }}

              toggleEnrollModalOpen={(therapist: TherapistData) => {
                setEnrollTherapistId(therapist.id);
                setEnrollTherapist(therapist);
                toggleEnrollModalOpen();

              }}
            />

          ))}

        </TherapistsList>

      )}

      <br />
      <br />

      {therapists?.length > 0 && (

        <Pagination

          currentPage={page}
          currentUrl={currentUrl}
          pageItemCount={count}
          totalItemCount={total || 0}
          initialTotalPage={initialTotalPage}
          onFlip={handleSetPage}

        />

      )}

      <br />

      {childTherapists ? (

        <InformationBlock />

      ) : null}

      {childTherapists && !isMobile ? (
        <HelpChooseChildPsy2 onClick={openModalForm} />
      ) : null}

      {/* old infinity scroll loading */}
      {/* {!isLoading && !isFetching && !therapists?.data?.length ? (
        <SearchNothingFoundState />
      ) : (
        <List
          ref={listRef}
          therapists={therapists}
          typeCard={typeCard}
          onReachEnd={handleReachEnd}
          isLoading={isLoading || isFetching}
        />
      )} */}

      <StyledSignUpModal

        isOpen={isAuthModalOpen}
        onClose={onCloseSignUpModal}
        withoutHeader

      >

        <SignUpModal />

      </StyledSignUpModal>

      <StyledEnrollModal

        isOpen={isEnrollModalOpen}
        onClose={toggleEnrollModalOpen}
        withoutHeader

      >

        {enrollTherapistId &&

          <EnrollModal

            onSubmitEnroll={gotoPaymentSession}
            onCancel={toggleEnrollModalOpen}
            therapist={enrollTherapist || { id: '', firstname: '', avatarKey: '' }}

          />

        }

      </StyledEnrollModal>

    </Root>

  );

};

const Root = styled.section`
  width: 100%;
  max-width: 960px;
  padding-bottom: 36px;
`;

const StyledModal = styled(Modal)`
  @media (max-width: ${BreakpointsEnum.sm}px) {
    && {
      max-width: 100%;
    }
  }
`;

const Title = styled.h1`
  margin-top: 10px;
  ${TYPOGRAPHY.heading3Bold24};
  color: #212731;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    margin-top: 0;
  }
`;

const Heading = styled.h3`
  margin-bottom: 0;
  ${TYPOGRAPHY.heading3Bold24}
  color: ${COLORS.primary300};

  span {
    ${TYPOGRAPHY.body1Regular16}
    color: ${COLORS.grayscale600};
  }

  @media (max-width: ${BreakpointsEnum.sm}px) {
    margin-bottom: 10px;
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;

    span {
      ${TYPOGRAPHY.body1Regular14}
    }
  }
`;

const LinkButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

const LinkButton = styled(Button)`
  width: 80%;
  padding: 14px 16px;
  ${TYPOGRAPHY.body1Semibold14};
  margin-bottom: 15px;
  color: ${COLORS.grayscale700};
  cursor: pointer;
  border: 1px solid ${COLORS.primary300};
  background-color: ${COLORS.white};
`;

const StyledTabs = styled(Tabs)`
  margin-bottom: 32px;

  button {
    width: auto;
    margin-right: 24px;
    padding: 0 0 8px;
  }
`;

const StyledInputWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: nowrap;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    display: block;
  }
`;

const StyledSearchInput = styled(SearchInput)`
  margin-bottom: 24px;
  min-width: calc(100% - 280px);
`;

const Controls = styled.div`
  margin: 24px 0;
  display: flex;
  align-items: center;
  gap: 40px;
`;

const SortingWrap = styled.div`
  position: relative;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
  }
`;

const StyledButton = styled(Button)`
  padding: 10px 21px;
`;

const SortButton = styled(StyledButton) <{ $hasSorting: boolean }>`
  ${({ $hasSorting }) =>
    $hasSorting &&
    css`
      color: ${COLORS.primary400};

      svg {
        color: ${COLORS.primary400};
      }
    `};

    @media (max-width: ${BreakpointsEnum.sm}px) {
      width: 100%;
    }
`;

const ButtonsWrap = styled.div`
  display: none;
`;

const StyledButtonFilters = styled(StyledButton)`
  @media (min-width: ${BreakpointsEnum.sm}px) {
    display: none;
  }
`;

const StyledSignUpModal = styled(Modal)`
  @media (min-width: ${BreakpointsEnum.sm}px) {
    max-width: 440px !important;
    padding: 0 !important;
  }
`;

const StyledEnrollModal = styled(Modal)`
  @media (min-width: ${BreakpointsEnum.sm}px) {
    max-width: 716px !important;
  }
`;

const TherapistsList = styled.div<{ $isRow: boolean }>`
	display:flex;
  gap: 11px 19px;
	flex-direction: column;
  margin-top: 10px;

  @media (max-width: ${BreakpointsEnum.md}px) {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  ${({ $isRow }) => {
    if ($isRow)
      return css`
        grid-template-columns: 1fr;
        gap: 20px;
        @media (max-width: ${BreakpointsEnum.md}px) {
          grid-template-columns: 1fr;
          gap: 20px;
        }
      `;
  }};

  @media (max-width: ${BreakpointsEnum.sm}px) {
    grid-template-columns: 1fr;
    gap: 80px;
  }

   @media (max-width: ${BreakpointsEnum.mb}px) {
    margin-top:0;
    gap:16px;

  }
`;

export default AllTherapists;

const StyledFlatBtn = styled(FlatBtn)`
  opacity: 0.7;
  transition: 0.3s;
  padding: 0;
  margin-bottom: 20px;

  div {
    margin-right: 4px;
  }

  svg {
    opacity: 0.7;
    transform: rotate(180deg);
  }
`;
